/**
 * Récupérer le timezone du navigateur
 * Remarque: GMT+1 devient GMT-1 en JS
 */
export function getBrowserTimeZone() {
    const offset = new Date().getTimezoneOffset()
    const hours = offset / 60
    const sign = hours >= 0 ? "+" : "-"
    return `GMT${sign}${Math.abs(hours)}`
}

/**
 * Convertir le timezone au format réel
 */
export function convertTZ (t: string) {
    return t.includes("+") ? t.replace("+", "-") : t.replace("-", "+")
}